<section class="auth-container">
    <!-- Logo modak text -->
    <figure class="logo-container">
      <img class="logo-text" [ngSrc]="'logo-text.svg' | staticServe" width="50" height="50" alt="">
    </figure>
    <figure class="image-container-mobile" *ngIf="showImageBannerMobile && useImageHeader">
      <img [ngSrc]="'teen_horizontal.webp' | staticServe" width="375" height="160" alt="teen" class="image-mobile" >
    </figure>
    <section class="segment">
      <section class="data-container">
        <ng-content></ng-content>
      </section>

      <section class="image-container" *ngIf="!isMobile && isShowingModakLogo" [ngStyle]="{ 'background-image': 'url(' + imageUrl + ')' }">
        <div class="overlay">
          <img [ngSrc]="'logo.svg' | staticServe" width="50" height="50" alt="modak" class="overlay-logo" >
        </div>
      </section>

      <picture class="image-teen-container" *ngIf="!isMobile && !isShowingModakLogo">
        <img [ngSrc]="'teen_vertical.webp' | staticServe" alt="teen" width="400" height="300">
      </picture>

    </section>
</section>